import React, { Fragment, useContext, useEffect } from "react";

import {
  BrowserRouter,
} from "react-router-dom";
import Secure from "../pages/secure";
import Public from "../pages/public";
import { AppContext } from "../context/AppContext";
import { getFromLocalStorage } from "../utils/common-utils";
import "../assets/js/page";
// Create a wrapper component for first login check
const SecureWithFirstLoginCheck = () => {
  const userData = getFromLocalStorage("userData");
  
  useEffect(() => {
    // Only redirect if firstLogin is explicitly false
    if (userData?.firstLogin === false && window.location.pathname !== '/dashboard') {
      window.location.href = '/dashboard';
    }
    // Don't redirect if firstLogin is true or undefined/null
  }, []);

  return <Secure />;
};

const RoutesData = () => {
  const { contexStates } = useContext(AppContext);
  const token = localStorage.getItem("token") || contexStates?.actualToken;
  
  // Determine which component to render
  let Routed = token ? SecureWithFirstLoginCheck : Public;

  return (
    <Fragment>
      <BrowserRouter>
        <Routed />
      </BrowserRouter>
    </Fragment>
  );
};

export default RoutesData;
